<script lang="ts" setup></script>

<template>
  <section class="observe">
    <div class="observe__top">
      <div class="observe__top__titleEn">observe</div>
      <div class="observe__top__titleTw">跳脫日常慣性，看見另一種過生活的方式 </div>
      <div class="observe__top__text">
        有時是否會覺得生活停滯不前，希望能跳出舒適圈，探索另一種未曾發現的自己、未曾看過的風景、未曾嘗試的生活。 讓恆隆行的《hence, 》雜誌與概念店 zonezone 與你一起找生活，看見另一種過生活的方式。
      </div>
    </div>
    <div class="observe__bottom">
      <div class="observe__bottom__item">
        <figure class="observe__bottom__pic"
          style="background-image: url('./images/story/hence.jpg');background-position-x:-300px;">
          <Nimg src="./images/story/hence.jpg" />
        </figure>
        <div class="observe__bottom__right">
          <div class="observe__bottom__title">《hence, 》雜誌</div>
          <div class="observe__bottom__text">
            2023年改版的《hence, 》雜誌，是恆隆行的全新自媒體，曾於2025年榮獲日本GOOD DESIGN AWARD 與台灣金點設計獎。藉由《hence,》陪伴每位讀者跳脫日常的慣性，「因此（hence），我們不止於現狀」，就像在逗號之後的留白，讓恆隆行與每一個你續寫著各種想像，翻開生活的下一頁。
          </div>
        </div>
      </div>
      <div class="observe__bottom__item">
        <div class="observe__bottom__right">
          <div class="observe__bottom__title">zonezone 概念店</div>
          <div class="observe__bottom__text">恆隆行始終致力於創新顧客體驗，2026年將以「BOLD勇於嘗試」為核心，重新定義 zonezone 為「生活品味玩家的聚所」。未來將延續既有全方位生活提案，並匯集質感摩登的生活型態，結合潮流時事與話題活動，邀請熱愛生活的不同世代玩家交流碰撞，開展更多歸屬與靈感。</div>
        </div>
        <figure class="observe__bottom__pic"
          style="background-image: url('./images/story/zonezone.jpg');background-position-x:420px;">
          <Nimg src="./images/story/zonezone.jpg" />
        </figure>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.observe {
  background-color: $color-white-1;
  padding-top: toRem(90);
  margin-left: toRem(-24);
  margin-right: toRem(-24);
  @include grid;

  @include max-media(640) {
    @include grid(4, 24);
  }

  &__top {
    position: relative;
    grid-column: 3 / span 8;
    text-align: center;
    margin-bottom: toRem(140);

    @include max-media(640) {
      grid-column: 1 / span 4;
      padding-left: toRem(24);
      padding-right: toRem(24);
      margin-bottom: toRem(100);
    }

    &__titleEn {
      margin-bottom: toRem(24);
      font-family: $font-TextaAlt;
      font-size: toRem(158);
      font-weight: 500;
      line-height: 0.8;
      color: $color-gray-3;

      @include max-media(640) {
        font-size: toRem(80);
      }
    }

    &__titleTw {
      margin-bottom: toRem(24);
      font-size: toRem(22);
      font-weight: 500;
      line-height: 1.3;
      color: $color-black-1;
    }

    &__text {
      font-size: toRem(16);
      line-height: 1.45;
      color: $color-gray-1;
    }
  }

  &__bottom {
    grid-column: 1 / span 12;

    @include max-media(640) {
      grid-column: 1 / span 4;
    }

    &__item {
      @include grid;
      align-items: center;

      @include max-media(767) {
        @include grid(4, 24);
      }

      &:not(:first-child) {
        margin-top: toRem(-135);

        @include max-media(1180) {
          margin-top: 0;
        }
      }

      &:nth-child(even) {
        .observe__bottom {
          &__pic {
            @include min-media(768) {
              grid-column: 7 / span 6;
              margin-left: toRem(-12);
            }

            @include max-media(767) {
              order: -1;
            }
          }

          &__right {
            @include min-media(768) {
              grid-column: 2 / span 4;
            }
          }
        }
      }

      &:nth-child(odd) {
        .observe__bottom {
          &__pic {
            margin-right: toRem(-12);
          }
        }
      }
    }

    &__pic {
      grid-column: 1 / span 6;

      @include min-media(768) {
        background-attachment: fixed;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      }

      @include max-media(767) {
        grid-column: 1 / span 4;
        background: none;
      }

      img {
        display: block;
        width: 100%;
        opacity: 0;

        @include max-media(767) {
          opacity: 1;
        }
      }
    }

    &__right {
      grid-column: 8 / span 4;

      @include max-media(767) {
        grid-column: 1 / span 4;
        padding-top: toRem(80);
        padding-bottom: toRem(80);
        padding-left: toRem(24);
        padding-right: toRem(24);
      }
    }

    &__title {
      margin-bottom: toRem(12);
      font-size: toRem(22);
      font-weight: 500;
      line-height: 1.3;
      color: $color-brand-3;
    }

    &__text {
      font-size: toRem(16);
      font-weight: 400;
      line-height: 1.45;
    }
  }
}
</style>
